import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatProductCategoryModel } from 'src/app/model/cat-product-category.model';
import { ComProductCategoryModel } from 'src/app/model/com-product-category.model';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductCategoryService } from 'src/oldApp/services/com-product-category.service';
import { CreatorService } from 'src/app/services/creator.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';
import { ModalScProductCategoryComponent } from 'src/oldApp/shared/modal-sc-product-category/modal-sc-product-category.component';

@Component({
  selector: 'app-sc-product-category',
  templateUrl: './sc-product-category.component.html',
  styleUrls: ['./sc-product-category.component.css']
})
export class ScProductCategoryComponent implements OnInit {
  // estado pagina
  public page:string='ScCategoryPromoter';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public categories:ComProductCategoryModel[]=[];

  // catalogos
  public productCategoryCatalog:CatProductCategoryModel[]=[];
  public employeeJobCatalog:CatEmployeeJobModel[]=[];
  public paymentTypeCatalog:CatalogModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    // dom: 'Bfrtip',
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private comProductCategoryService:ComProductCategoryService,
    private catProductCategoryService:CatCategoryProductService,
    private catEmployeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add=()=> {
    let category=this.creator.newComProductCategoryModel();
    let modalRef=this.modalService.open(ModalScProductCategoryComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.category=category;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.componentInstance.categories=this.categories;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(category:ComProductCategoryModel)=> {
    let modalRef=this.modalService.open(ModalScProductCategoryComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.category={...category};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.componentInstance.categories=this.categories;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  productCategory=item=> this.productCategoryCatalog.find(cat=> cat.productCategoryId===item.productCategoryId).description;
  employeeJob=item=> this.employeeJobCatalog.find(job=> job.employeeJobId===item.employeeJobId).description;
  payment=item=> this.paymentTypeCatalog.find(pay=> pay.id===item.paymentId).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.comProductCategoryService.getAll(),
      this.catProductCategoryService.getAll(),
      this.catEmployeeJobService.getAll(),
      this.vwCommissionConfiguratorService.getPayments()
    )
    .pipe(
      tap(([prodCatResp, prodCatCatResp, employeeJobCatResp, payTypeResp]:[any, any, any, any])=> {
        if(prodCatResp && prodCatCatResp && employeeJobCatResp && payTypeResp) {
          this.categories=prodCatResp.data;
          this.productCategoryCatalog=prodCatCatResp.data;
          this.employeeJobCatalog=employeeJobCatResp.data;
          this.paymentTypeCatalog=payTypeResp.data;
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos'));
      })
    )
    .subscribe();
  }
}
